import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useIntersectionObserver } from 'usehooks-ts';
import { BellIcon, Cross1Icon } from '@radix-ui/react-icons';
import { useCounts, useNotifications, useNovu } from '@novu/react';

import { Drawer } from '../../components/drawer/drawer';
import { NotificationsList } from './notifications-list';
import { ToolBar } from '../../components/toolbar/toolbar';

import styles from './notification-center.module.scss';
export const NotificationCenter: React.FC = observer(() => {
  const novu = useNovu();
  const { hasMore, fetchMore } = useNotifications();
  const { counts } = useCounts({
    filters: [
      { read: false }, // Unread notifications
    ],
  });

  const unreadCount = counts?.[0]?.count ?? 0;

  const [isCenterOpen, setIsCenterOpen] = useState(false);

  const notificationListRef = useRef<HTMLDivElement>(null);

  const { isIntersecting, ref: lastItemRef } = useIntersectionObserver({
    root: notificationListRef.current,
    threshold: 0.1,
  });

  useEffect(() => {
    if (isIntersecting && hasMore) {
      fetchMore();
    }
  }, [isIntersecting, fetchMore, hasMore]);

  const handleMarkAllAsRead = () => {
    novu.notifications.readAll();
  };

  return (
    <>
      <button
        className={styles['bell-button']}
        id="bell-button"
        data-testid="notification-icon"
        data-count={unreadCount}
        onClick={() => setIsCenterOpen((isOpen) => !isOpen)}
      >
        <BellIcon />
      </button>

      <Drawer
        className={styles['notification-drawer']}
        isOpen={isCenterOpen}
        onPointerDownOutside={(e) => {
          const target = e.target as HTMLElement;

          if (target?.id === 'bell-button') {
            e.preventDefault();
          }
        }}
        onCancel={() => setIsCenterOpen(false)}
        mobileFullHeight
      >
        <ToolBar title={'Notifications'}>
          <div className={styles['actions']}>
            <button
              className={styles['mark-read-button']}
              onClick={handleMarkAllAsRead}
              data-testid="mark-as-read"
            >
              Mark all as read
            </button>

            {/* <IconButtonWrapper>
              <IconButton icon={<MixerHorizontalIcon />} onClick={() => setIsCenterOpen(false)} />
            </IconButtonWrapper> */}

            {/* <IconButtonWrapper>
              <IconButton icon={<GearIcon />} onClick={() => setIsCenterOpen(false)} />
            </IconButtonWrapper> */}

            <button
              className={styles['close-button']}
              onClick={() => setIsCenterOpen(false)}
              aria-label="Close"
            >
              <Cross1Icon />
            </button>
          </div>
        </ToolBar>

        <div className={styles['list']} ref={notificationListRef}>
          <button
            className={styles['mark-read-button']}
            onClick={handleMarkAllAsRead}
            data-testid="mark-as-read"
          >
            Mark all as read
          </button>

          <NotificationsList ref={lastItemRef} onItemClick={() => setIsCenterOpen(false)} />
        </div>
      </Drawer>
    </>
  );
});
